import PageHeader from "app/shared/PageHeader";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import "./DashboardView.scss";

export default function DashboardView() {
  const location = useLocation();
  const [userDetails] = useRecoilState<any>(userInfo);
  const [updatedLink, setUpdatedLink] = useState("");
  const { dashboard_link, zoho_criteria } = location.state;

  const fetchDashboardLink = () => {
    let link = dashboard_link;

    if (userDetails.currentWorkspace?.name.includes("Admin")) {
      setUpdatedLink(link);
    } else {
      const encodedWorkspaceName = encodeURIComponent(userDetails.currentWorkspace?.name);
      const actualUrl = zoho_criteria && zoho_criteria !== ""
        ? `${link}?ZOHO_CRITERIA=%22${zoho_criteria}%22%3D%27${encodedWorkspaceName}%27`
        : link;

      setUpdatedLink(actualUrl);
    }
  };

  useEffect(() => {
    fetchDashboardLink();
  }, [userDetails.currentWorkspace]);

  return (
    <div className="DashboardView" style={{ height: "100%" }}>
      <div className="PageHeaderContainer">
        <PageHeader title="Dashboard View" goBack />
      </div>
      <div className="MainContainer">
        <iframe
          height="100%"
          style={{ width: "100%" }}
          scrolling="no"
          title="Dashboard Iframe"
          src={updatedLink || dashboard_link}
        ></iframe>
      </div>
    </div>
  );
}
